import { Button } from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import useSLotLocking from '../hooks/useSlotLocking';
import CountdownCircle from './CountdownCircle';

const LockedSlotReminder = ({ onRelease }) => {
  const currentGolf = useSelector((state) => state.app.golf);
  const courses = useSelector((state) => state.bookingData.courses);
  const lockedSlot = useSelector((state) => state.bookingData.lockedSlot);

  const { releaseSlot } = useSLotLocking();
  const [isExpired, setIsExpired] = useState(false);

  if (!lockedSlot || lockedSlot.golfId !== currentGolf.id) return null;

  const course = courses.find((c) => c.id === lockedSlot.courseId);
  if (!course) return null;

  const handleRelease = async () => {
    try {
      await releaseSlot();
      if (typeof onRelease === 'function') onRelease();
    } catch {
      // if (typeof onError === 'function') onError(); ?
      // ou dans le composant
    }
  };

  const handleExpire = () => {
    setIsExpired(true);
  };

  return (
    <Box display='flex' flexDirection='row' alignItems='center'>
      <CountdownCircle
        onExpire={handleExpire}
        duration={lockedSlot.ttl}
        expiresAt={lockedSlot.expiresAt}
        timeOffset={lockedSlot.serverTimeOffset}
      />
      {!isExpired && (
        <Box marginLeft={3}>
          <Button size='small' color='secondary' variant='contained' onClick={handleRelease}>
            {'Annuler'}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default LockedSlotReminder;
